__turbopack_context__.v({
  "embla": "MyCarousel-module-scss-module__CKwICG__embla",
  "embla__button": "MyCarousel-module-scss-module__CKwICG__embla__button",
  "embla__button__container": "MyCarousel-module-scss-module__CKwICG__embla__button__container",
  "embla__button__next": "MyCarousel-module-scss-module__CKwICG__embla__button__next",
  "embla__button__prev": "MyCarousel-module-scss-module__CKwICG__embla__button__prev",
  "embla__button__svg": "MyCarousel-module-scss-module__CKwICG__embla__button__svg",
  "embla__container": "MyCarousel-module-scss-module__CKwICG__embla__container",
  "embla__dot": "MyCarousel-module-scss-module__CKwICG__embla__dot",
  "embla__dots": "MyCarousel-module-scss-module__CKwICG__embla__dots",
  "embla__slide": "MyCarousel-module-scss-module__CKwICG__embla__slide",
  "embla__slide__img": "MyCarousel-module-scss-module__CKwICG__embla__slide__img",
  "embla__slide__inner": "MyCarousel-module-scss-module__CKwICG__embla__slide__inner",
  "embla__viewport": "MyCarousel-module-scss-module__CKwICG__embla__viewport",
  "footer": "MyCarousel-module-scss-module__CKwICG__footer",
  "footer__link": "MyCarousel-module-scss-module__CKwICG__footer__link",
  "footer__link__svg": "MyCarousel-module-scss-module__CKwICG__footer__link__svg",
  "header": "MyCarousel-module-scss-module__CKwICG__header",
  "is_draggable": "MyCarousel-module-scss-module__CKwICG__is_draggable",
  "is_dragging": "MyCarousel-module-scss-module__CKwICG__is_dragging",
  "is_selected": "MyCarousel-module-scss-module__CKwICG__is_selected",
});
